import {
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE
} from "../Constants";

const init = {
    data: {},
};

const ChangePasswordReducer = (state = init, action) => {
    switch (action.type) {
        case CHANGE_PASSWORD:
            return { ...state, loading: true };
        case CHANGE_PASSWORD_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case CHANGE_PASSWORD_FAILURE:
            return { ...state, loading: false, data: action.payload };
        default:
            return state;
    }
};

export default ChangePasswordReducer;